/*
	FILESYSTEM MIXINS
*/
//------------------------------------------------------------
// IMPORT
//------------------------------------------------------------

import { mapActions } from 'vuex';

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	methods: {
		...mapActions('gameOS', [
		    'openWindow',
		    'selectIcon'
		]),

		//------------------------------------------------------------
		// DRAG ICON
		//------------------------------------------------------------

		// drag(target) {
		// 	var obj = JSON.stringify(target);
	 //        event.dataTransfer.setData('text', obj);

	 //        // console.log(event.target.getAttribute('node'));
	 //        // event.dataTransfer.setData("text", event.target.getAttribute('uid'));
	 //        // event.dataTransfer.setData('text', event.target);
	 //    },

	    //------------------------------------------------------------
	    // DROP
	    //------------------------------------------------------------

	    // drop() {
	    //     var dropTarget = event.dataTransfer.getData('text');
	    //     var droppedGridSquareId = event.target.getAttribute('uid');

	    //     // console.log(JSON.parse(dropTarget));
	    //     console.log(JSON.parse(dropTarget) + ' dropped into: '+droppedGridSquareId);
	    //     console.log(event.target);

	    //     // this.$store.dispatch('gameOS/updateIconPosition', {
	    //     //     id: droppedGridSquareId,
	    //     //     obj: JSON.parse(dropTarget)
	    //     // });
	    // },

	    //------------------------------------------------------------
	    // SELECT ICON
	    //------------------------------------------------------------

		select(node) {
		    if (node.children) {
		        this.$emit('select', node.children);
		        // console.log(node.children); // keep drilling
		    }
		    else {
		        // launch program
		        this.openWindow('appFileSystem')
		    }
		},
	}
}

//------------------------------------------------------------
//
//------------------------------------------------------------
//===========================================
//
//===========================================